import ExpandMore from "@mui/icons-material/ExpandMore";
import { AccordionProps } from "@mui/material";
import { ContactResponse } from "@/main/models/response";

import ContactCard from "./contactCard/contactCard";
import * as S from "./styles";

export interface IInfoProcurement {
	companyName: string;
	claimNumber: string;
	orderNumber: string;
	vehicleName: string;
	insurerName: string;
}

interface IAcordeonContactProps {
	title: string;
	dataContacts: ContactResponse[];
	isCollapse?: boolean;
	infoProcurement: IInfoProcurement;
	propsCollapse?: Omit<AccordionProps, "children">;
}

function AccordionContacts({ title, dataContacts, infoProcurement, propsCollapse }: IAcordeonContactProps) {
	return (
		<S.AccordionContactStyle {...propsCollapse}>
			<S.AccordionSummaryContact
				id={`id-modalcontact-accordion-contact-${title}`}
				aria-controls="categories-content"
				expandIcon={<ExpandMore fontSize="medium" />}
			>
				<S.AccordionTitle>{title}</S.AccordionTitle>
			</S.AccordionSummaryContact>
			{dataContacts.map((contact) => (
				<S.AccordionDetailsContacts key={contact.guid} id={`id-scrollable-target-contact-${title}`}>
					<S.ContentContacts>
						<ContactCard key={contact.guid} contact={contact} infoProcurement={infoProcurement} />
					</S.ContentContacts>
				</S.AccordionDetailsContacts>
			))}
		</S.AccordionContactStyle>
	);
}

export default AccordionContacts;
